export const menuAppBarItems = [{
  title: 'Zurich',
  image: '/images/menuAppBar/logoZBig.png',  
	}, {
  title: 'Sistemi Informativi S.r.l.',
  image: '/images/menuAppBar/logo-grande_SI.png',
},
];